export default class MediaItem {
    constructor(html, name, when) {
        this.html = html;
        this.name = name;
        this.when = when;

        if(!this.html.jquery) {
            this.html = $(this.html);
        }

        this.key = this.html.attr('data-key');
    }
}